import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Globals } from '../globals';
import { FirestoreService } from './firestore/firestore.service';

export interface SecurityReport{
  id?: string;
  active?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  employeeId: string;
  employeeName: string;
  date: string;
  time: string;
  employees: SecurityReportEmployee[];
  userEmail: string;
}

export interface SecurityReportEmployee{
  id: string;
  name: string;
  time: string;
}

@Injectable()
export class SecurityReportService {

  collection: string = Globals.SECURITY_REPORT_COLLECTION;

  constructor(
    private afh: FirestoreService,
    private router: Router,
  ) { }

  /**
   * Get all securityReports with references
   * @return {Observable} Arrays of securityReports
   */
  getSecurityReports({fromDate = '', equalsDate = ''}: { fromDate?: string | Date, equalsDate?: string | Date } = {}): Observable<SecurityReport[]> {
    console.log(`Get Security reporrts `, { fromDate, equalsDate })
    let col;
    if(fromDate){
      if(fromDate instanceof Date) fromDate = fromDate.toISOString().slice(0, 10)
      col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true).where('date', '>=', fromDate) );
    }else if(equalsDate){
      if(equalsDate instanceof Date) equalsDate = equalsDate.toISOString().slice(0, 10)
      console.log(`Filtering security report with date == "${equalsDate}"`, equalsDate);
      col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true).where('date', '==', equalsDate) );
    }else{
      col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
    }
    return col;
  }

  /**
  * Get securityReport data
  * @param {string} sid - The id of the securityReport
  * @return {Observable} The SecurityReport Object
  */
  getSecurityReport(sid: string): Observable<SecurityReport> {
    return this.afh.docWithIds$(`${this.collection}/${sid}`);
  }

  /**
  * Create new securityReport
  * @param {SecurityReport} securityReport - The data of the securityReport
  */
  addSecurityReport(securityReport: SecurityReport) {
    return this.afh.addPromise(`${this.collection}`, securityReport);
  }

  /**
   * Update current securityReport
   * @param {string} sid  - The id of the securityReport
   * @param {SecurityReport} securityReport - The data of the securityReport
   */
  updateSecurityReport(sid: string, securityReport: Partial<SecurityReport>) {
    return this.afh.update(`${this.collection}/${sid}`, securityReport);
  }

  /**
   * Delete current securityReport
   * @param {string} sid - The id of the securityReport
   */
  deleteSecurityReport(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  windowReplace = {
    add: () => this.router.navigate([`/add_securityReport`]),
    read: () => this.router.navigate([`/securityReport`]),
    edit: (id: string) => this.router.navigate([`/edt_securityReport/${id}`]),
    view: (id: string) => this.router.navigate([`/vw_securityReport/${id}`]),
  };
}
